import theme from "@/theme";

export const styles = {
  mainTitle: {
    fontWeight: 800,
    fontSize: "32px",
    lineHeight: 1.2,
    mb: 4,
  },

  sectionTitle: {
    fontWeight: 700,
    fontSize: "26px",
    mb: 2,
  },

  bodyText: {
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: 1.6,
    color: "#000",
  },

  highlightedText: {
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: 1.6,
    color: "#000",
  },
  listItemTitle: {
    fontWeight: 600,
    fontSize: "18px",
    lineHeight: 1.6,
    color: "#000",
  },
  listItem: {
    display: "flex",
    alignItems: "flex-start",
    padding: 0,
    "&::before": {
      content: '"•"',
      fontWeight: 700,
      display: "inline-block",
      width: "1em",
      fontSize: "20px",
      flexShrink: 0,
      color: "#000",
    },
  },

  nestedList: {
    pl: 4,
  },

  link: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 500,
    fontSize: "15px",
    lineHeight: "150%",
    letterSpacing: "0%",
    textDecoration: "underline",
    textDecorationColor: theme.palette.custom.mainBlue,
    textDecorationThickness: "1px",
    textUnderlineOffset: "3px",
    cursor: "pointer",
  },
};
